<form [formGroup]="formGroup">
  <bit-form-field>
    <bit-label>{{ "emailAddress" | i18n }}</bit-label>
    <input
      id="web-register-email"
      bitInput
      type="email"
      formControlName="email"
      [placeholder]="'emailAddress' | i18n"
      [attr.readonly]="emailReadonly ? true : null"
    />
  </bit-form-field>

  <bit-form-field>
    <bit-label>{{ "name" | i18n }}</bit-label>
    <input
      id="web-register-name"
      bitInput
      type="text"
      formControlName="name"
      [placeholder]="'name' | i18n"
    />
  </bit-form-field>
</form>

<auth-input-password
  [flow]="inputPasswordFlow"
  [email]="emailValue"
  [loading]="submitting"
  [primaryButtonText]="{ key: 'createAccount' }"
  (onPasswordFormSubmit)="handlePasswordSubmit($event)"
></auth-input-password>

<div [formGroup]="formGroup" class="tw-mt-3">
  <bit-form-control>
    <input
      id="web-register-accept-terms"
      type="checkbox"
      bitCheckbox
      formControlName="acceptTerms"
    />
    <bit-label for="web-register-accept-terms">
      {{ "byContinuingYouAgreeToThe" | i18n }}
      {{ "termsOfService" | i18n }}
      {{ "and" | i18n }}
      <a bitLink routerLink="/privacy" target="_blank" rel="noopener noreferrer">{{
        "privacyPolicy" | i18n
      }}</a
      >.
    </bit-label>
  </bit-form-control>
</div>
